/**
 * The original runtime's localStorage contract (app/app.js `store`):
 * values are JSON-encoded; a missing key, unreadable storage or corrupt
 * value reads back as the caller's default; writes are not guarded.
 * Legacy code and extracted React features share this storage, so the
 * semantics here must stay byte-compatible with the original.
 */
export function readStoredJson<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key);
    return raw == null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function writeStoredJson(key: string, value: unknown): void {
  window.localStorage.setItem(key, JSON.stringify(value));
}
